const comment = (merchant) => {
  return merchant
    ? '// A reference to Stripe.js initialized with your real test publishable API key.'
    : '// A reference to Stripe.js initialized with a fake API key.\n// Sign in to see examples pre-filled with your key.';
};

export default ({demo, keys, server, merchant}) => `${comment(merchant)}
{+init-stripe}
var stripe = Stripe("${keys.publishable}");
{/init-stripe}

// The items the customer wants to buy
var purchase = {
  items: [{ id: "xl-tshirt" }]
};

// Disable the button until we have Stripe set up on the page
document.querySelector("button").disabled = true;
{+fetch-pi}
fetch("${server === 'php' ? '/create.php' : '/create-payment-intent'}", {
  method: "POST",
  headers: {
    "Content-Type": "application/json"
  },
  body: JSON.stringify(purchase)
})
{/fetch-pi}
  .then(function(result) {
    return result.json();
  })
  .then(function(data) {
    {+init-elements}
    var elements = stripe.elements();
    {/init-elements}

    {+style-element input}
    var style = {
      base: {
        color: {span animate cardText}"${demo.cardText}"{/span},
        fontFamily: {span animate cardFont}'${demo.cardFont}'{/span},
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: {span animate cardText}"${demo.cardText}"{/span}
        }
      },
      invalid: {
        fontFamily: {span animate cardFont}'${demo.cardFont}'{/span},
        color: {span animate cardInvalid}"${demo.cardInvalid}"{/span},
        iconColor: {span animate cardInvalid}"${demo.cardInvalid}"{/span}
      }
    };
    {/style-element}

    {+create-element}
    var card = elements.create("card", { style: style });
    // Stripe injects an iframe into the DOM
    card.mount("#card-element");
    {/create-element}

    {+listen-for-change}
    card.on("change", function (event) {
      // Disable the Pay button if there are no card details in the Element
      document.querySelector("button").disabled = event.empty;
      document.querySelector("#card-error").textContent = event.error ? event.error.message : "";
    });
    {/listen-for-change}

    {+form-submit}
    var form = document.getElementById("payment-form");
    form.addEventListener("submit", function(event) {
      event.preventDefault();
      // Complete payment when the submit button is clicked
      payWithCard(stripe, card, data.clientSecret);
    });
    {/form-submit}
  });

// Calls stripe.confirmCardPayment
// If the card requires authentication Stripe shows a pop-up modal to
// prompt the user to enter authentication details without leaving your page.
var payWithCard = function(stripe, card, clientSecret) {
  loading(true);
  {+complete-payment}
  stripe
    .confirmCardPayment(clientSecret, {
      {?email email-1}
      receipt_email: document.getElementById('email').value,
      {/email-1}
      payment_method: {
        card: card
      }
    })
  {/complete-payment}
  {+js-6}
    .then(function(result) {
      if (result.error) {
        // Show error to your customer
        showError(result.error.message);
      } else {
        // The payment succeeded!
        orderComplete(result.paymentIntent.id);
      }
    });
  {/js-6}
};

/* ------- UI helpers ------- */

// Shows a success message when the payment is complete
var orderComplete = function(paymentIntentId) {
  loading(false);
  document
    .querySelector(".result-message a")
    .setAttribute(
      "href",
      "https://dashboard.stripe.com/test/payments/" + paymentIntentId
    );
  document.querySelector(".result-message").classList.remove("hidden");
  document.querySelector("button").disabled = true;
};

// Show the customer the error from Stripe if their card fails to charge
var showError = function(errorMsgText) {
  loading(false);
  var errorMsg = document.querySelector("#card-error");
  errorMsg.textContent = errorMsgText;
  setTimeout(function() {
    errorMsg.textContent = "";
  }, 4000);
};

// Show a spinner on payment submission
var loading = function(isLoading) {
  if (isLoading) {
    // Disable the button and show a spinner
    document.querySelector("button").disabled = true;
    document.querySelector("#spinner").classList.remove("hidden");
    document.querySelector("#button-text").classList.add("hidden");
  } else {
    document.querySelector("button").disabled = false;
    document.querySelector("#spinner").classList.add("hidden");
    document.querySelector("#button-text").classList.remove("hidden");
  }
};
`;
